/*
 * File: ui.slice.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on June 17, 2022 at 10:03 AM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: July 21, 2022 at 1:00 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice } from '@reduxjs/toolkit';

// Utilities
import { getCookie, setCookie } from '../../../utilities/cookies';

// Constants
import { UI_MODE_COOKIE, UI_MODE_OPTIONS, UI_MODE_COOKIE_EXPIRATION } from '../../../../Constants';


/**
 * Constants
 */

export const initialState = {
	status: 'idle',
	error: null,
	value: {
		isSet: false,
		mode: getCookie(UI_MODE_COOKIE) || UI_MODE_OPTIONS.LIGHT
	},
};


/**
 * Slices
 */

export const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		updateUI: (state, action) => {

			// Update cookie
			setCookie(UI_MODE_COOKIE, action.payload.mode, action.payload.merchant, UI_MODE_COOKIE_EXPIRATION);

			// Create final payload
			const payload = { ...action.payload };
			delete payload.merchant;

			// Set state
			state.value = {
				...payload,
				isSet: true
			};
		},
		clearUI: (state, action) => {

			// Update cookie
			setCookie(UI_MODE_COOKIE, UI_MODE_OPTIONS.LIGHT, action.payload.merchant, UI_MODE_COOKIE_EXPIRATION);

			// Clear state
			state.value = {
				...initialState.value,
				isSet: true
			};
		},
	},
	extraReducers: {},
});


/**
 * Exports
 */

export const { updateUI, clearUI } = uiSlice.actions;

export default uiSlice.reducer;
